import { tx } from "shared/types/i18n";

import { FormTextInput } from "../../components/form/form-text-input";
import { isEmailRegex } from "../../util/regex";
import { DataCollectionImplementation } from "../types";

export const emailInput: DataCollectionImplementation = {
  wasCompleted: (user) => !!user.userAttributes?.email,
  Component: ({ errors, register, user }) => {
    const showEmailInput =
      (!user.userAttributes?.email && !user.userAttributes?.finishedSignUp) ||
      user.userAttributes.finishedSignUp;

    return showEmailInput ? (
      <FormTextInput
        labelClassName="font-bold"
        defaultValue={user?.userAttributes?.email ?? ""}
        title={{ tx: "auth.signUp.inputs.email.title" }}
        placeholder={{ tx: "auth.signUp.inputs.email.placeholder" }}
        autoComplete="username"
        {...register("email", {
          required: tx("auth.signUp.inputs.email.fieldMissingError"),
          pattern: {
            value: isEmailRegex,
            message: tx("auth.signUp.inputs.email.notAnEmailError"),
          },
          value: user?.userAttributes?.email ?? "",
        })}
        error={{ txUnchecked: errors.email?.message }}
      />
    ) : null;
  },
};
